import { Component, Input } from '@angular/core';

import { Event, Venue } from "../../../models";
import { StringDatePipe } from '../../../ui-helper/string-date.pipe';

@Component({
	selector: 'event-with-venue',
	templateUrl: "./event-with-venue.html",
	styles: [require("./event-with-venue.scss")]
})
export class EventWithVenue {

	@Input() event: Event
	@Input() venue: Venue

	private showEventPopup: boolean = false;

	private showEventInfo(): void {
		this.showEventPopup = true;
	}

	private closeEventInfo(): void {
		this.showEventPopup = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-tickets/event-with-venue/event-with-venue.component.ts